import BaseSelector from './base';

export default class VariantData extends BaseSelector {
  prefix = 'variant-data';
  normalizedData = (dataset) => ({
    ...dataset,
    ...dataset.subscriptionPrice ? { subscriptionPrice: parseInt(dataset.subscriptionPrice) } : {},
    ...dataset.subscriptionId ? { subscriptionId: parseInt(dataset.subscriptionId) } : {},
    ...dataset.servings ? { servings: parseInt(dataset.servings) } : {},
    ...dataset.productOutOfStock ? { productOutOfStock: JSON.parse(dataset.productOutOfStock) } : {},
    productId: parseInt(dataset.productId),
    variantId: parseInt(dataset.variantId),
    price: parseFloat(dataset.price)
  });
}
